const targetSystems = [
    {
        id: "guestProfile",
        apiName: "Gjesteprofil på hotell",
        title: "systemGuestProfile",
        include: false
    },
    {
        id: "thonPlus",
        apiName: "THON+ (medlemskap Thon Hotels)",
        title: "systemThonPlus",
        include: false
    },
    {
        id: "customerClub",
        apiName: "Kundeklubb kjøpesenter",
        title: "systemCustomerClub",
        include: false
    },
    {
        id: "thonEiendom",
        apiName: "Thon Eiendom",
        title: "systemThonEiendom",
        include: false
    },
    {
        id: "timePark",
        apiName: "Time Park",
        title: "systemTimePark",
        include: false
    },
    {
        id: "recruitment",
        apiName: "Rekruttering",
        title: "systemRecruitment",
        include: false
    },
    {
        id: "other",
        apiName: "Annet",
        title: "systemOther",
        include: false
    }
];

export default targetSystems;
